<template>
    <div class="Footer">
        <a href="https://www.engineering.columbia.edu/"><img :src="img_columbia_logo" class="CE" /></a>
        <a href="https://www.columbia.edu/"><img :src="img_columbia" class="CU" /></a>
        <a href="https://www.cs.columbia.edu/"><img :src="img_cucs" class="CUCS"></a>
    </div>
</template>

<script>
import img_columbia_logo from '@/assets/img/ColEng.png'
import img_columbia from '@/assets/img/Columbia.png'
import img_cucs from '@/assets/img/CUCS.png'

export default {
    name: 'Footer',
    data() {
        return {
            img_columbia_logo,
            img_columbia,
            img_cucs
        }
    }
}
</script>

<style>
/* colors */
:root {
    --footer-background-color: #000000;
    --footer-text-color: #ffffff;
}

/* ul */
.Footer {
    bottom: 0;
    width: 100%;
    height: 120px;
    background-color: var(--footer-background-color);
}

.CE {
    padding-top: 40px;
    width: 300px;
    height: 47px;
}

.CU {
    padding-top: 40px;
    padding-right: 60px;
    float: right;
    width: 300px;
    height: 47px;
}

.CUCS {
    padding-top: 40px;
    padding-left: 60px;
    float: left;
    width: 300px;
    height: 47px;
}
</style>